import { ReactNode, useEffect, useRef } from 'react';
import { CustomerInformationContainerProps } from '@msc-b2c/interfaces/types';

import { CustomerInformationContainer } from './CustomerInformationContainer';
import { usePrivateAreaPageViewTracking } from '../utils/analyticsUtils';
import { AppDispatch, getActiveSession, membershipsData, RootState } from '@msc-b2c/shared-utils';
import { getMembershipData } from '../utils/myAreaUtils';
import { LoginMode } from '@msc-b2c/interfaces/enums';
import { useDispatch, useSelector } from 'react-redux';

export function CustomerInformationContainerWrapper({
  dataComponentName,
  passwordSectionTitleIcon,
  passwordSectionTitle,
  passwordSectionCtaLabel,
  passwordSectionCtaLink,
  fullLoginAuthenticationExchangePage,
  phoneAndEmailSectionTitleIcon,
  phoneAndEmailSectionTitle,
  phoneAndEmailSectionCtaLabel,
  emailLabel,
  phoneNumberLabel,
  mobileNumberLabel,
  addressSectionTitleIcon,
  addressSectionTitle,
  addressSectionCtaLabel,
  addressLabel,
  cityLabel,
  postalCodeLabel,
  verifyZipCodeButtonEnabled,
  verifyZipCodeButtonLabel,
  stateLabel,
  privacySectionTitleIcon,
  privacySectionTitle,
  privacySectionCtaLabel,
  enableCheckboxTitleAndSubtitle = false,
  privacyAgreementText,
  formPrivacyFields,
  popupPrivacyTitle,
  popupPrivacyCloseIcon,
  formAddressFields,
  popupAddressTitle,
  popupAddressCloseIcon,
  formPhoneEmailFields,
  popupPhoneEmailTitle,
  popupPhoneEmailCloseIcon,
  popupPrivacySubmitButtonLabel,
  popupPrivacyCancelButtonLabel,
  popupAddressSubmitButtonLabel,
  popupAddressCancelButtonLabel,
  popupPhoneEmailSubmitButtonLabel,
  popupPhoneEmailCancelButtonLabel,
  errorCtaLabel,
  errorClosingIcon,
  errors,
}: Readonly<CustomerInformationContainerProps>): ReactNode {
  const dispatch = useDispatch<AppDispatch>();
  const { loginMode } = getActiveSession();
  const { membershipData } = useSelector((state: RootState) => state.myCruise);
  const membershipRequestInProgress = useRef(false);
  usePrivateAreaPageViewTracking();

  useEffect(() => {
    if (membershipRequestInProgress.current || loginMode !== LoginMode.FULL || membershipData) {
      return;
    }

    membershipRequestInProgress.current = true;
    getMembershipData()
      .then((res) => {
        dispatch(membershipsData(res?.memberships ? res : { memberships: [] }));
      })
      .finally(() => {
        membershipRequestInProgress.current = false;
      });
  }, [dispatch, loginMode, membershipData]);

  const props = {
    dataComponentName,
    passwordSectionTitleIcon,
    passwordSectionTitle,
    passwordSectionCtaLabel,
    passwordSectionCtaLink,
    fullLoginAuthenticationExchangePage,
    phoneAndEmailSectionTitleIcon,
    phoneAndEmailSectionTitle,
    phoneAndEmailSectionCtaLabel,
    emailLabel,
    phoneNumberLabel,
    mobileNumberLabel,
    addressSectionTitleIcon,
    addressSectionTitle,
    addressSectionCtaLabel,
    addressLabel,
    cityLabel,
    postalCodeLabel,
    verifyZipCodeButtonEnabled,
    verifyZipCodeButtonLabel,
    stateLabel,
    privacySectionTitleIcon,
    privacySectionTitle,
    privacySectionCtaLabel,
    enableCheckboxTitleAndSubtitle,
    privacyAgreementText,
    formPrivacyFields,
    popupPrivacyTitle,
    popupPrivacyCloseIcon,
    formAddressFields,
    popupAddressTitle,
    popupAddressCloseIcon,
    formPhoneEmailFields,
    popupPhoneEmailTitle,
    popupPhoneEmailCloseIcon,
    popupPrivacySubmitButtonLabel,
    popupPrivacyCancelButtonLabel,
    popupAddressSubmitButtonLabel,
    popupAddressCancelButtonLabel,
    popupPhoneEmailSubmitButtonLabel,
    popupPhoneEmailCancelButtonLabel,
    errorCtaLabel,
    errorClosingIcon,
    errors,
  };

  return <CustomerInformationContainer {...props} />;
}

CustomerInformationContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/customerinformationcontainer';

export default CustomerInformationContainerWrapper;
